const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-footer'] = {
        c: () => require('partner/modules/ecomm-footer/ecomm-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-footer'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-footer|ecomm-footer'] = {
                c: () => require('partner/modules/ecomm-footer/ecomm-footer.view.tsx'),
                cn: '__local__-__local__-ecomm-footer'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };